import React from 'react'
import { CFooter } from '@coreui/react'
import { useAppSelector } from '../redux/hooks'
import { selectCurrentUser } from '../redux/features/currentUser/currentUserSlice'
import { _dictionary } from '../utils/translate'
import { _clientVersion } from '../_config'

const AppFooter = () => {
  const currentUser = useAppSelector(selectCurrentUser)
  const translate = _dictionary(currentUser?.active_language || null)

  const _serverVersion =
    typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem('globalConfiguration') || '{}')?.server_version || '0.0.0'
      : '0.0.0'
  const platformName =
    typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem('globalConfiguration') || '{}')?.platform_name ||
        'ERP Solution 企業資源規劃方案'
      : 'ERP Solution 企業資源規劃方案'

  return (
    <CFooter>
      <div>
        <span className="ms-1">
          &copy; {new Date().getFullYear()} {platformName}
        </span>
      </div>
      <div className="ms-auto">
        <span className="me-1">
          {translate('Version: ')}vC.{_clientVersion}-S.{_serverVersion}
        </span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
